import _ from "lodash";

/* 
  Copied from LoginModule.js to remove circular dependency. 
  Will remove it from here once LoginModule is restructured to LoginReducer 
 */
const setToastMsg = data => {
  return { type: "SET_TOAST_MSG" + " " + "login", payload: data };
};

// --------------------------------------------

export const dispatchError = ({
  dispatch,
  customMessage,
  notString,
  e,
  position = "toast-bottom-left",
}) => {
  const msg =
    customMessage ||
    (_.get(e, "networkError")
      ? "toastMsgs:no_internet_connection"
      : "toastMsgs:something_went_wrong");

  dispatch(
    setToastMsg({
      msg,
      type: "warning",
      position,
      notString,
    })
  );
};
